import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [],
  template: `
    <div class="error-page">
      <h2>Access Denied</h2>
      <p>
        You do not have permission to access this application.
        Please contact your administrator to request access.
      </p>
      <p class="hint">Already been granted access? Click <strong>Try Again</strong> to refresh your session.</p>
      <div class="btn-row">
        <button class="btn-retry"   (click)="tryAgain()">Try Again</button>
        <button class="btn-signout" (click)="signOut()">Sign Out</button>
      </div>
    </div>
  `,
  styles: [`
    .error-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: calc(100vh - 64px);
      padding: 2rem;
      text-align: center;
    }
    h2        { font-size: 2rem; color: #b00020; margin-bottom: 1rem; }
    p         { color: #555; margin-bottom: 1rem; max-width: 480px; }
    .hint     { font-size: 0.9rem; color: #888; }
    .btn-row  { display: flex; gap: 1rem; margin-top: 1rem; }
    .btn-retry, .btn-signout {
      padding: 0.6rem 1.5rem;
      border: none;
      border-radius: 4px;
      font-weight: 600;
      cursor: pointer;
      color: #fff;
    }
    .btn-retry   { background: #107c10; }
    .btn-signout { background: #0078d4; }
  `],
})
export class UnauthorizedComponent {
  constructor(private authService: MsalService) {}

  /** Force a fresh login — bypasses the cached token so new role assignments are picked up */
  tryAgain(): void {
    this.authService.loginRedirect({ scopes: [], prompt: 'login' });
  }

  signOut(): void {
    this.authService.logoutRedirect({ postLogoutRedirectUri: '/' });
  }
}
